import axios, { AxiosPromise } from 'axios';

export interface IcisMeny {
    value: string;
    labelcz: string;
    labelen: string;
}

export interface ISezMen {
    cisMeny: IcisMeny[];
}

const cisMenyApi = (): AxiosPromise<IcisMeny[]> => {
    return axios({
        method: 'GET',
        url: '/Ciselnik/CisMeny'
    });
};

export default cisMenyApi;
